export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'Vstupenky byly resetované...',
        networkError: 'Chyba komunikace se serverem, zkontrolujte prosím přípojení k internetu...',
        networkNotAvailable: 'Nepřipojeno'
    },
    menu: {
        test: 'Test čtečky kódů',
        settings: 'Nastavení',
        admin: 'Administrace',
        resetTickets: 'Reset vstupenek',
        resetState: 'Reset stavu aplikace',
        logout: 'Odhlásit'
    },
    home: {
        login: 'Přihlásit se',
        lastEvent: 'Kontrolovat poslední načtenou událost / zónu',
        lastEvents: 'Kontrolovat poslední<br />načtené události',
        lastZones: 'Kontrolovat poslední<br />načtené zóny',
        chooseEvent: 'Vyberte akci',
        checkEvents: 'Kontrolovat<br />události',
        checkZones: 'Kontrolovat<br />zóny',
        scanConfig: 'Načíst QR kód'
    },
    configScanner: {
        title: 'Konfigurační QR',
        notConfig: 'Nerozpoznaný konfigurační kód',
        loggedIn: 'Přihlášeno:',
        setsSelected: 'Vybrány sady:',
        zonesSelected: 'Vybrána zóna:',
        loginRequiredTitle: 'Nutné přihlášení',
        loginRequiredMessage: 'Pro načtení sad nebo zón se musíte nejdřív přihlásit.',
        counterOn: 'Počítadlo zapnuto',
        counterOff: 'Počítadlo vypnuto',
        langSet: 'Jazyk přepnut',
        scanInfoSet: 'Mód info po skenu nastaven',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Vyberte akci',
        chooseEventPast: 'Proběhlé akce',
        confirm: 'Potvrdit výběr akcí',
        showPast: 'zobrazit proběhlé akce'
    },
    zone: {
        chooseZone: 'Vyberte zónu / zóny',
        confirm: 'Potvrdit výběr zón'
    },
    ticketsets: {
        chooseTicketsets: 'Vyberte sadu vstupenek',
        selectAll: 'Vybrat všechny',
        ticketCount: 'Počet vstupenek:'
    },
    scanner: {
        tickets: 'Vstupenek:',
        startReader: 'Spustit čtečku',
        startReaderDescription:
            'Prohlížeč potřebuje interakci uživatele pro spuštění systémových zvuků nutných pro upozorňování. Potvrďte prosím tlačítkem "OK"',
        specialWarning: 'Upozornění',
        specialType: 'Vstupenka je speciálního typu:',
        refuse: 'Odmítnout',
        confirm: 'Potvrdit',
        messageSuccess: 'Kód {code} úspěšně uplatněn',
        messageSuccessPrice: 'Kód {code} úspěšně uplatněn<br /><big>Cena: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: 'Kód {code} úspěšně uplatněn<br /><big>Sada: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: 'Kód {code} úspěšně uplatněn<br /><big>Sada vst.: <b>{ticketset}</b></big>',
        messageSuccessEvent: 'Kód {code} úspěšně uplatněn<br /><big>Akce: <b>{event}</b>, sada: {ticketset}</big>',
        messageSuccessNosend: 'Kód {code} úspěšně uplatněn (neodesláno)',
        messageRead: 'Byl načten kód {code}',
        messageUsed: 'Kód {code} byl již použit',
        messageNotUsable: 'Kód {code} není možné použít',
        messageUnsend: 'Kód {code} byl již použit (mnou, neodeslán)',
        messageNotFound: 'Kód <b>{code}</b> nenalezen v načtených vstupenkách',
        messageBadSlot: 'Kód {code} není platný pro tuto zónu/slot',
        messageExtra1: 'použit na zařízení: <b>{device}</b>, datum: <b>{date}</b>',
        manualTitle: 'Ruční vložení kódu',
        loading: 'nahrávám vstupenky...',
        nfcNotFound: 'Žádná ze vstupenek na kartě není platná'
    },
    login: {
        title: 'Přihlášení do aplikace',
        username: 'Přihlašovací jméno',
        password: 'Heslo',
        login: 'Přihlásit'
    },
    settings: {
        title: 'Nastavení',
        sound: 'Zvuk',
        soundSub: 'Zapnutí zvukových upozornění',
        camera: 'Kamera',
        nfc_heading: 'NFC',
        nfc: 'Číst NFC tagy',
        language: 'Jazyk',
        langCs: 'Česky',
        langEn: 'Anglicky',
        langDe: 'Německy',
        langHr: 'Chorvatsky',
        langHu: 'Maďarsky',
        langPl: 'Polsky',
        langSk: 'Slovensky',
        qTitle: 'Detailní nastavení čtečky',
        qPatchSize: 'Velikost dekódovacího okna',
        qFrequency: 'Frekvence dekódování',
        groupDisplay: 'Zobrazení skupiny / kategorie při kontrole',
        groupDisplayNone: 'Nezobrazovat nic',
        groupDisplayTicketset: 'Zobrazit sady vstupenek',
        groupDisplayTicketsetPrice: 'Zobrazit sady vstupenek a cenovou hladinu',
        groupDisplayPrice: 'Zobrazit cenovou hladinu',
        groupDisplayEvent: 'Zobrazit jméno události a sadu',
        olderEvents: 'Jak dlouho zobrazovat události po jejich ukončení',
        olderEventsWeek: 'Týden',
        olderEventsMonth: 'Měsíc',
        olderEvents3Month: '3 mesíce',
        olderEvents6Month: '6 měsíců',
        olderEventsYear: '1 rok',
        olderEventsAll: 'Zobrazit všechny',
        olderEventsAllList: 'všechny',
        showTicketCount: 'Zobrazit počet vstupenek',
        showStatistics: 'Zobrazit statistiky',
        queueTitle: 'Seznam kódů ve frontě k odeslání',
        queueSending: 'probíhá odesílání',
        queueYes: 'ANO',
        queueNo: 'NE',
        queueEmpty: 'Fronta je prázdná'
    },
    statistics: {
        title: 'Statistiky použití vstupenek',
        zone: 'Zóna',
        today: 'Dnes',
        total: 'Celkem',
        refresh: 'Obnovit data'
    },
    verify: {
        title: 'Ověření vstupenky',
        enterCode: 'Zadejte kód vstupenky',
        verify: 'Ověřit',
        scanHint: 'Naskenujte kód nebo zadejte ručně',
        notFound: 'Vstupenka nenalezena',
        found: 'Vstupenka nalezena',
        email: 'E-mail',
        entries: 'Vstupů',
        people: 'Osob',
        entryPause: 'Odstup vstupu (min)',
        purchased: 'Zakoupena',
        validUntil: 'Platná do',
        event: 'Událost',
        ticketset: 'Sada vstupenek',
        price: 'Cenová hladina',
        zones: 'Zóny',
        noZones: 'Vstupenka není přiřazena k žádné zóně.',
        slots: 'Sloty',
        noSlots: 'Vstupenka není přiřazena k žádnému slotu.',
        usageForZone: 'Využití v zóně',
        remains: 'Zbývá',
        usageLogs: 'Záznam použití vstupenek',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'Nové ověření'
    }
} as const
